module.exports = __webpack_public_path__ + "img/info.d7e145e6.svg";